"use client";

import { useState } from "react";
import {
  Popover,
  PopoverAnchor,
  PopoverContent,
  PopoverTrigger,
} from "@/components/ui/popover";
import { SidebarMenu } from "@/components/ui/sidebar";
import { shouldShowGettingStartedWidget } from "@/hooks/use-getting-started-progress";
import { useGettingStartedTasks } from "@/hooks/use-getting-started-tasks";
import { GettingStartedSidebarItem } from "./getting-started-sidebar-item";
import { GettingStartedPanel } from "./getting-started-panel";

// The menu sits inside the sidebar's 12px padding; 12 + 16 puts the panel 16px past the sidebar edge.
const SIDEBAR_EDGE_OFFSET = 28;

export const GettingStartedWidget = () => {
  const [isPanelOpen, setIsPanelOpen] = useState(false);
  const { isSuccess, completedAt, tasks, isJurniCoreMissing } =
    useGettingStartedTasks();
  const completedCount = tasks.filter(
    (task) => task.completed || task.dismissed,
  ).length;

  // A missing script brings Account Setup back even after the widget expired.
  const showWidget =
    isSuccess &&
    (isJurniCoreMissing || shouldShowGettingStartedWidget(completedAt));

  if (!showWidget) return null;

  return (
    <Popover open={isPanelOpen} onOpenChange={setIsPanelOpen}>
      {/* A real, always-mounted anchor: a virtualRef anchor can get stuck on a
          detached trigger node in this Radix version and pin the panel to the
          window's top-left corner. */}
      <PopoverAnchor asChild>
        <SidebarMenu>
          <PopoverTrigger asChild>
            <GettingStartedSidebarItem
              completedCount={completedCount}
              totalCount={tasks.length}
              isJurniCorePending={isJurniCoreMissing}
            />
          </PopoverTrigger>
        </SidebarMenu>
      </PopoverAnchor>
      <PopoverContent
        side="right"
        align="end"
        sideOffset={SIDEBAR_EDGE_OFFSET}
        collisionPadding={8}
        onCloseAutoFocus={(e) => e.preventDefault()}
        className="w-[min(24rem,calc(100vw-1rem))]"
      >
        <GettingStartedPanel onTaskNavigate={() => setIsPanelOpen(false)} />
      </PopoverContent>
    </Popover>
  );
};
